import { actions as boardsActions } from "app/containers/Features/containers/Boards/components/Settings/redux/slice";
import { ticketGroupsActions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import { actions } from "app/redux/slice";
import { useDispatch, useSelector } from "react-redux";
import { GroupByTypeEnum } from "../types";
import { selectDraftBoardForm } from "./Settings/redux/selector";

type UpdateCallback = () => void;
type UpdateCallbackWithGroupBy = (
  groupBy: GroupByTypeEnum,
  subGroupBy: GroupByTypeEnum,
) => void;

export const useBoardsActions = (projectId: string) => {
  const dispatch = useDispatch();
  const boardForm = useSelector(selectDraftBoardForm);

  const fetchBoardsGroupsJson = (
    boardId: string,
    groupBy?: GroupByTypeEnum,
    subgroupBy?: GroupByTypeEnum,
    callback?: UpdateCallback,
  ) => {
    dispatch(
      ticketGroupsActions.fetchBoardsGroupsJson({
        boardId,
        groupBy: groupBy ?? boardForm?.groupBy,
        subgroupBy: subgroupBy ?? boardForm.subGroupBy,
        callback: callback ?? (() => {}),
      }),
    );
  };
  const updateBoardsGroupsJson = (
    boardId: string,
    callback?: UpdateCallback,
  ) => {
    dispatch(
      boardsActions.updateBoardsGroupJson({
        boardId,
        callback: callback ?? (() => {}),
      }),
    );
  };

  const fetchBoardDetails = (
    boardId: string,
    callback?: UpdateCallbackWithGroupBy,
  ) => {
    dispatch(
      boardsActions.fetchBoardDetails({
        id: boardId,
        callback: callback ?? (() => {}),
      }),
    );
  };
  const updateBoard = (boardId: string, callback: UpdateCallback) => {
    dispatch(
      boardsActions.updateBoard({
        id: boardId,
        callback: callback ?? (() => {}),
      }),
    );
  };
  const fetchProjectSettings = (projectId: string) => {
    dispatch(actions.fetchProjectSettings(projectId));
  };
  const fetchBoardsMenus = () => {
    if (!projectId) return;
    dispatch(actions.doGetBoardsMenu({ id: projectId }));
  };
  const toggleBoardSetting = (value: boolean) => {
    dispatch(boardsActions.toggleBoardSetting(value));
  };

  return {
    fetchBoardDetails,
    fetchBoardsMenus,
    fetchProjectSettings,
    updateBoard,
    fetchBoardsGroupsJson,
    updateBoardsGroupsJson,
    toggleBoardSetting,
  };
};
